(function () {

	document.querySelectorAll('.selectmulti').forEach(function(select) {
		select.querySelectorAll('input').forEach(function(input) {
			input.addEventListener('change', function() {
				let values = [];
				select.querySelectorAll('input:checked').forEach(function(checkbox) {
					if ( checkbox.closest('.tw-toggle') ) {
						if ( checkbox.value !== '' ) {
							values.push(checkbox.closest('.tw-toggle').nextElementSibling.textContent);
						}
					} else {
						values.push(select.querySelector('label[for="' + checkbox.id + '"]').textContent);
					}
				});
				if (values.length)
					select.querySelector('button span').textContent = values.join(', ');
				else
					select.querySelector('button span').textContent = select.querySelector('button').dataset.text;
			});
		});
	});

})();